import { attachApiErrorMessageMiddleware } from "@/lib/utils/api/api-error-middleware";
import { getActiveRoleRequestHeaders } from "@/lib/utils/api/active-role-header";
import { getEffectiveTenantApiHeaders } from "@/lib/utils/env/effective-tenant";
import { Configuration } from "@/openapi/generated";
import type {
  ConfigurationParameters,
  HTTPHeaders,
  Middleware,
} from "@/openapi/generated/runtime";
import { BASE_PATH } from "@/openapi/generated/runtime";

/** Reads the switched-on role when the request leaves, so a later role change is not stale. */
export const attachActiveRoleHeaderMiddleware: Middleware = {
  pre: async ({ url, init }) => {
    const roleHeaders = getActiveRoleRequestHeaders();
    if (Object.keys(roleHeaders).length === 0) return;

    const headers = new Headers(init.headers);
    for (const [name, value] of Object.entries(roleHeaders)) {
      headers.set(name, value);
    }

    return { url, init: { ...init, headers } };
  },
};

export function resolveOpenApiBasePath(): string {
  const fromEnv =
    typeof process !== "undefined" && process.env.NEXT_PUBLIC_API_URL
      ? String(process.env.NEXT_PUBLIC_API_URL).replace(/\/+$/, "")
      : "";
  return (fromEnv || BASE_PATH).replace(/\/+$/, "");
}

export function createOpenApiConfiguration(
  params: ConfigurationParameters = {},
): Configuration {
  const basePath = params.basePath ?? resolveOpenApiBasePath();
  const tenantHeaders = getEffectiveTenantApiHeaders();
  const mergedHeaders: HTTPHeaders = {
    ...tenantHeaders,
    ...(params.headers ?? {}),
  };
  return new Configuration({
    ...params,
    basePath,
    headers: mergedHeaders,
    middleware: [
      attachActiveRoleHeaderMiddleware,
      attachApiErrorMessageMiddleware,
      ...(params.middleware ?? []),
    ],
  });
}
